const capitalizeFirst = require('./utils/capitalizeFirst');
const sanitizeKilogramms = require('./utils/sanitizeKilogramms');

/**
 * Вес для показа человеку.
 *
 * Точные 171 г и 59 г пугают: кажется, что нужны аптечные весы.
 * Поэтому от 50 г округляем до пяти, от 10 до 50 — до грамма,
 * а мелочь не трогаем вовсе — иначе 2 г чили превратились бы в 5,
 * а это уже другое блюдо.
 *
 * Округляется только показ. Расчёты КБЖУ идут по точному весу,
 * поэтому цифры программы не меняются. Проверено на 400 программах
 * стенда: типичный день расходится на 0,4%, худший на 2,3% —
 * меньше, чем ошибка самого подбора порций
 * (bod-knowledge decisions/display-rounding.md).
 *
 * Лежит в `lib`, а не в сервисе программ, потому что считает это
 * и сервер, и браузер: в карточке рецепта человек переключает число
 * порций, и граммовки пересчитываются на месте. Правило округления
 * должно быть одно — иначе сервер покажет 150 г, а браузер 148.
 */
function roundWeightForDisplay(weightGramms) {
    if (weightGramms < 10) return Math.ceil(weightGramms);
    if (weightGramms < 50) return Math.round(weightGramms);
    return Math.round(weightGramms / 5) * 5;
}

/**
 * Подпись веса: граммы до 800, дальше килограммы.
 *
 * Дробная часть отделяется запятой, как во всех числах для человека.
 */
function getWeightTitle(weightGrammsExact = 0) {
    const weightGramms = roundWeightForDisplay(weightGrammsExact);
    const weightKilogramms = sanitizeKilogramms(weightGrammsExact / 1000);
    return capitalizeFirst(weightGrammsExact > 800
        ? `${String(weightKilogramms).replace('.', ',')} кг`
        : `${weightGramms} г`);
}

module.exports = { roundWeightForDisplay, getWeightTitle };
